// DocumentsTable.tsx
import { Button, Divider, Flex, Grid, Modal, Text } from "@mantine/core";
import { useState } from "react";
import { useParams } from "react-router";
import PlusIcon from "../common/Icons/PlusIcon";
import { theme } from "../../theme";
import DocumentUploadModal from "./DocumentUploadModal";
import TableDeleteButton from "../common/Buttons/TableDeleteButton";
import TableDownloadButton from "../common/Buttons/TableDownloadButton";
import AreYouSureModal from "../common/Modals/AreYouSureModal";
import {
  deleteEmployeeDocument,
  downloadEmployeeDocument,
  previewEmployeeDocument,
  uploadEmployeeDocument, // bunu backend’de varsa çağıracağız
} from "../../api/employeeApi";
import {
  deleteNotification,
  creationNotification,
} from "../../utils/useNotification";
import TablePreviewButton from "../common/Buttons/TablePreviewButton";

const DocumentsTable = ({ documents, reFetchData }: any) => {
  const { id }: any = useParams();
  const [itemToDeleteId, setitemToDeleteId] = useState<any>();
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [opened, setOpened] = useState(false);
  const [uploadTargetDocId, setUploadTargetDocId] = useState<string | null>(
    null
  );

  const [newFile, setNewFile] = useState<any>(null);
  const [newName, setNewName] = useState<string>("");

  const [loading, setLoading] = useState<any>(false);

  const handleDeleteClick = async (docId: any) => {
    try {
      const { data }: any = await deleteEmployeeDocument({
        fileId: docId,
        employeeId: id,
      });
      deleteNotification(data?.success);
      reFetchData();
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const handleCreate = async () => {
    if (!newFile || !newName.trim()) return;
    try {
      setLoading(true);
      const { data }: any = await uploadEmployeeDocument({
        employeeId: id,
        file: newFile,
        name: newName,
        fileId: uploadTargetDocId || undefined,
      });

      if (data?.success) {
        creationNotification("Belge", true);
        setOpened(false);
        setNewFile(null);
        setNewName("");
        setUploadTargetDocId(null);
        reFetchData();
        setLoading(false);
      } else {
        //error
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const requiredDocs = documents?.required || [];
  const otherDocs = documents?.other || [];

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "15px" }}>
      <Flex w={"100%"} justify={"space-between"} align={"center"}>
        <Text fw={600} fz={20} c="black">
          Özlük Belgeleri
        </Text>
        <Button
          color={theme.colors.brand.normal}
          leftSection={<PlusIcon />}
          onClick={() => setOpened(true)}
        >
          Yeni Özlük Belgesi
        </Button>
      </Flex>

      {/* Belgeler */}
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "15px",
          width: "100%",
        }}
      >
        {/* Required Documents */}
        {requiredDocs.length > 0 && (
          <>
            <Divider my="md" label="Zorunlu Belgeler" labelPosition="center" />

            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fill, minmax(180px, 1fr))",
                gap: "16px",
              }}
            >
              {requiredDocs.map((doc: any) => (
                <div
                  key={doc.id}
                  style={{
                    border: "1px solid #E5E7EB",
                    borderRadius: "6px",
                    padding: "8px",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    aspectRatio: "1 / 1",
                    alignItems: "center",
                    gap: "35px",
                  }}
                >
                  <Text>{doc?.name}</Text>
                  <Flex gap={8} justify="center">
                    {doc?.fileId ? (
                      <>
                        <TableDownloadButton
                          onClick={(e: any) => {
                            e.stopPropagation();
                            downloadEmployeeDocument(doc?.fileId);
                          }}
                        />
                        <TableDeleteButton
                          onClick={(e: any) => {
                            e.stopPropagation();
                            setitemToDeleteId(doc?.fileId);
                            setOpenDeleteModal(true);
                          }}
                        />
                        <TablePreviewButton
                          onClick={(e: any) => {
                            e.stopPropagation();
                            previewEmployeeDocument(doc?.fileId);
                          }}
                        />
                      </>
                    ) : (
                      <Button
                        color={theme.colors.brand.normal}
                        onClick={() => {
                          setUploadTargetDocId(doc.id);
                          setNewName(doc.name);
                          setOpened(true);
                        }}
                      >
                        Yükle
                      </Button>
                    )}
                  </Flex>
                </div>
              ))}
            </div>
          </>
        )}

        {/* Other Documents */}
        {otherDocs.length > 0 && (
          <>
            {requiredDocs.length > 0 && (
              <Divider my="md" label="Diğer Belgeler" labelPosition="center" />
            )}
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fill, minmax(180px, 1fr))",
                gap: "16px",
              }}
            >
              {otherDocs.map((doc: any) => (
                <div
                  key={doc.fileId}
                  style={{
                    border: "1px solid #E5E7EB",
                    borderRadius: "6px",
                    padding: "8px",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    aspectRatio: "1 / 1",
                    alignItems: "center",
                    gap: "35px",
                  }}
                >
                  <Text>{doc?.name}</Text>
                  <Flex gap={8} justify="center">
                    <TableDownloadButton
                      onClick={(e: any) => {
                        e.stopPropagation();
                        downloadEmployeeDocument(doc?.fileId);
                      }}
                    />
                    <TableDeleteButton
                      onClick={(e: any) => {
                        e.stopPropagation();
                        setitemToDeleteId(doc?.fileId);
                        setOpenDeleteModal(true);
                      }}
                    />
                    <TablePreviewButton
                      onClick={(e: any) => {
                        e.stopPropagation();
                        previewEmployeeDocument(doc?.fileId);
                      }}
                    />
                  </Flex>
                </div>
              ))}
            </div>
          </>
        )}
      </div>

      {/* Modal’lar aynı */}
      <Modal
        opened={opened}
        title="Özlük Belgesi Yükleme"
        centered
        onClose={() => {
          if (!loading) setOpened(false);
        }}
        withCloseButton={!loading} // yüklenirken çarpı gizleniyor
        closeOnClickOutside={!loading} // dışarı tıklama engelli
        closeOnEscape={!loading} // esc kapatma engelli
        keepMounted={false}
      >
        <DocumentUploadModal
          file={newFile}
          name={newName}
          setFile={setNewFile}
          setName={setNewName}
          isRequiredDoc={!!uploadTargetDocId}
          isLoading={loading}
        />
        <Flex justify="space-between" mt="md">
          <Button
            color="gray"
            mr="sm"
            onClick={() => {
              if (!loading) setOpened(false);
            }}
          >
            Vazgeç
          </Button>
          <Button
            color={theme.colors.brand.normal}
            onClick={() => {
              if (!loading) handleCreate();
            }}
          >
            Kaydet
          </Button>
        </Flex>
      </Modal>

      <AreYouSureModal
        opened={openDeleteModal}
        setOpened={setOpenDeleteModal}
        proccessFunc={() => handleDeleteClick(itemToDeleteId)}
        title="Belgeyi Sil"
        text="Bu belgeyi silmek istediğinizden emin misiniz?"
        confirmButtonText="Sil"
        cancelButtonText="Vazgeç"
      />
    </div>
  );
};

export default DocumentsTable;
